import { Box } from "@chakra-ui/react";

import { initials } from "@/helpers/initials";

type Props = {
  displayName: string;
  kind: "org" | "merchant";
  size?: string;
};

/**
 * Solid brand purple for an organización, a soft tint of it for a comercio, so
 * the two groups read apart at a glance without leaving the palette.
 */
const STYLES = {
  org: { bg: "palomma.500", color: "white" },
  merchant: { bg: "palomma.100", color: "palomma.700" },
} as const;

/** The square initials tile that stands in for a context everywhere it appears. */
const ContextAvatar = ({
  displayName,
  kind,
  size = "32px",
}: Props): JSX.Element => (
  <Box
    boxSize={size}
    flexShrink={0}
    display="flex"
    alignItems="center"
    justifyContent="center"
    borderRadius="md"
    bg={STYLES[kind].bg}
    color={STYLES[kind].color}
    fontSize="xs"
    fontWeight={700}
  >
    {initials(displayName)}
  </Box>
);

export default ContextAvatar;
